/// <amd-module name="typeahead/core/ConfigurableFeature" />

/// <reference path="../../typings/typeahead/ABTest.d.ts" />

import {IOverrideParams} from "typeahead/core/IOverrideParams";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

export abstract class ConfigurableFeature {
    public static getFeatureOverrides($input: any): any {
        let featuresOverrides = {};
        let featureOverrideString = $input.data("feature-overrides");
        if (featureOverrideString) {
            let featureStrings = featureOverrideString.split("|");
            if (featureStrings) {
                for (let featureString of featureStrings) {
                    let splitIndex = featureString.indexOf(":");
                    if (splitIndex !== -1) {
                        let key = featureString.substring(0, splitIndex);
                        let val = featureString.substring(splitIndex + 1, featureString.length);
                        featuresOverrides[key] = val;
                    }
                }
            }
        }
        return featuresOverrides;
    }

    protected abstract configuration: IStripingConfiguration[];
    protected abstract featureName: string;

    protected shouldOverride(options: IOverrideParams): JQueryPromise<boolean> {
        let deferred: JQueryDeferred<boolean> = $.Deferred();
        let overrideValue: string = this.getOverrideValue(options);
        if (!overrideValue) {
            return deferred.reject().promise();
        }

        if (this.isOverrideToOn(overrideValue)) {
            return deferred.resolve(true).promise();
        }

        if (this.isOverrideToOff(overrideValue)) {
            return deferred.resolve(false).promise();
        }

        if (overrideValue.indexOf("=") !== -1) {
            let split = overrideValue.split("=");
            if (split.length === 2) {
                let key = split[0];
                let val = split[1];
                switch (key) {
                    case "@experiment":
                        return this.checkExperiment(val, deferred);
                    default:
                        break;
                }
            }
        }
        return deferred.reject().promise();
    }

    private isOverrideToOn(overrideValue: string) {
        return overrideValue === "on";
    }

    private isOverrideToOff(overrideValue: string) {
        return overrideValue === "off";
    }

    private checkExperiment(experimentName: string, deferred: JQueryDeferred<boolean>): JQueryPromise<boolean> {
        let experiment = {
            id: 0,
            name: experimentName,
        };
        ExecutionHelper.evaluateExperiment(experiment, deferred);
        return deferred.promise();
    }

    private getOverrideValue(options: IOverrideParams) {
        return options && options.featureOverrides && this.featureName && options.featureOverrides[this.featureName];
    }
}
